import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { Constants } from 'src/app/shared/vo/Constants';

@Component({
  selector: 'app-school-assistance',
  templateUrl: './school-assistance.component.html',
  styleUrls: ['./school-assistance.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class SchoolAssistanceComponent implements OnInit {
  currentUser: any;
  security: SecurityDocument;
  workShopDetail: any;
  dataParent: any;

  listParticipantAny: any;

  cols: any[];

  lbl_go_Back: string = "back_";
  lbl_name: string = "name_";
  lbl_last_name: string = "last_name_";
  lbl_church_name: string = "church_name_";
  lbl_workshop: string = "workshop_";
  lbl_schedule: string = "schedule_";
  lbl_updated_data = "updated_data_";
  lbl_status: string = "status_";
  lbl_10a15a_particip: string = "10a15a_particip_";
  lbl_guide: string = "guide_";
  lbl_is_not_valid: string = "is_not_valid_";

  totalList: any;


  // RESTAURAR ROWS
  rowCloned: any;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService) {
      //const navigation = this.router.getCurrentNavigation();
      //this.dataParent = navigation.extras.state as any;
      this.initConfigs() 

  }

  ngOnInit(): void {
    if (this.dataParent) {

      this.security = this.dataParent.security;
      this.workShopDetail = this.dataParent.workshop;

      this.getSecurity();
    } else {

      this.currentUser = this.authenticationService.currentUserValue;

      this.redirectWorkShop();
    }
  }

  initConfigs() {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation?.extras?.state || {};
    if (this.dataParent) {
      const { security, selStore, selPeriod } = this.dataParent;
      if (!Constants.selStore) {
        Constants.selStore = selStore;
        Constants.itemsNavigation = this.dataParent?.itemsNavigation;
      }
      //this.selStore = Constants.selStore;

      //this.selStoreId = Constants.selStore.storeId;
    }
  }

  redirectWorkShop() {

        let obj = {
          eppg: this.dataParent.eppg,
          security: this.security
        }
        let queryParamsDetail = {}
        if (this.currentUser && this.currentUser.tokenProfile) {
          /*queryParamsDetail = {
            token: this.currentUser.tokenProfile,
            view: 'schoolfpgDetail',
            wrksId: this.dataParent.data.wrksId
          }*/
        }
        let navigationExtras: NavigationExtras = {
          queryParams: queryParamsDetail,
          state: JSON.parse(JSON.stringify(obj))
        }

        if(this.dataParent.view && this.dataParent.view == "schoolfpgDetail"){
          this.router.navigate(['catalogs/eppgs/schoolfpgDetail'], navigationExtras);
        }else{
          this.router.navigate(['guide/workshops'], navigationExtras);
        }
  }

  getSecurity() {

    if (!this.security) {

      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();

        });
    } else {
      this.getTranslatedLabels();


    }
    if (!this.workShopDetail) {

    }


  }

  loadParticipants() {

    let body = {
      wrksId: this.workShopDetail.f0.wrksId,
      language: this.security.language
    }
    this.listParticipantAny = [];
    this.cols = [];
    this.cols = [
      { field: 'guide', fieldFirst: "name", header: this.lbl_name },
      { field: 'guide', fieldFirst: "lastName", header: this.lbl_last_name },
      { field: 'guide', fieldFirst: "status", header: this.lbl_status }
    ];


    this.apiService.ListFGByServiceAllSession(body).then(
      participants => {


        this.listParticipantAny = participants;
        this.calculateTotal();
        let index = 0;
        if (this.listParticipantAny.length > 0) {
          for (let p of this.listParticipantAny[0]["sessions"]) {

            let head = {
              header: p.sessNum,
              field: 'sessions',
              fieldFirst: index,
              fieldSecond: 'isAssist'
            }
            index++;


            this.cols.push(head);
          }

        }


      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'loadFG' + error + "/", detail: "Error " + error + "/", life: 3000 });
      });
  }


  calculateTotal() {
    const sessionsArrays = this.listParticipantAny.map(p => p["sessions"]);
    const mergedSessions = [].concat(...sessionsArrays);

    this.totalList = mergedSessions.reduce((acc, session) => {
      const existingSession = acc.find(s => s.sessNum === session.sessNum);

      if (existingSession) {
        existingSession.isAssist += session.isAssist ? 1 : 0;
      } else {
        acc.push({ isAssist: session.isAssist ? 1 : 0, sessNum: session.sessNum });
      }

      return acc;
    }, []);
  }

  /**
 * The `deepClone` function recursively creates a deep copy of an object or array in TypeScript.
 * @param obj - The `obj` parameter in the `deepClone` function is the object that you want to create a
 * deep copy of. The function recursively clones the object and all its nested properties to create a
 * new object that is completely independent of the original object.
 * @returns The `deepClone` function is returning a deep copy of the input `obj`, meaning it creates a
 * new object or array with all nested objects and arrays also deeply copied.
 */
  deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    const cloned = Array.isArray(obj) ? [] : {};

    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        cloned[key] = this.deepClone(obj[key]);
      }
    }

    return cloned;
  }

  /**
   * The `onRowEditInit` function initializes the editingRowIndex and clones the rowData if it has not
   * been cloned before.
   * @param rowData - The `rowData` parameter in the `onRowEditInit` function represents the data of the
   * row being edited in a table or list. It contains the information and values of the row that the user
   * is currently editing.
   * @param {number} ri - The `ri` parameter in the `onRowEditInit` function represents the index of the
   * row being edited in the list of participants.
   */
  onRowEditInit(assist: any, ri: number) {
    if (!this.rowCloned) {
      this.rowCloned = this.deepClone(assist);
    }
  }

  onRowEditSave(assist: any, ri: number) {
    console.debug(assist);

    const body = {
      language: this.security.language,
      guideId: assist.guide.guideId,
      wrksId: this.workShopDetail.f0.wrksId,
      sessions: assist.sessions

    }

    if (assist.guide.status == 'A') {
      this.apiService.createUpdateListFGAttendande(body).then(
        data => {

          if (data.status == "OK") {

            this.messageService.add({ severity: 'success', summary: this.lbl_updated_data, detail: "", life: 4000 });
            this.getDetailForm0();
            this.loadParticipants();
          } else {
            // RESTAURAMOS ROW
            this.listParticipantAny[ri] = this.rowCloned;
            delete this.rowCloned;

            this.messageService.add({ severity: 'error', summary: data.errorMessage, detail: " ", life: 9000 });
          }


        }).catch(error => {

          // RESTAURAMOS ROW
          this.listParticipantAny[ri] = this.rowCloned;
          delete this.rowCloned;

          console.error(error);
          this.messageService.add({ severity: 'error', summary: 'Actualización Asistencia', detail: "Error al registrar", life: 3000 });
        });;
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error ' + this.lbl_status, detail: `${this.lbl_status} ${this.lbl_guide} ${this.lbl_is_not_valid}`, life: 3000 });
    }

  }


  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_guide, this.lbl_is_not_valid, this.lbl_go_Back, this.lbl_name, this.lbl_last_name, this.lbl_church_name, this.lbl_workshop, this.lbl_schedule, this.lbl_updated_data, this.lbl_status, this.lbl_10a15a_particip]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_last_name = map.get(this.lbl_last_name);
        this.lbl_church_name = map.get(this.lbl_church_name);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_updated_data = map.get(this.lbl_updated_data);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_10a15a_particip = map.get(this.lbl_10a15a_particip);
        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_is_not_valid = map.get(this.lbl_is_not_valid);
        this.loadParticipants();
      });
  }

  getDetailForm0() {
    this.apiService.getDetailForm0({
      wrksId: this.workShopDetail.f0.wrksId
    }).then(
      data => {
        this.workShopDetail.f0.partN15s = data.partN15s;
        this.workShopDetail.f0.partN2s = data.partN2s;
      }
    );
  }

}
